import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuebar from "vuebar";
import ElementUI from "element-ui";
import VueAreaLinkage from "vue-area-linkage";
import AppPlugin from "./plugin";
import i18n from "./utils/language";
import VueQuillEditor, { Quill } from "vue-quill-editor";
import ImageResize from "quill-image-resize-module";
import VueClipboard from "vue-clipboard2";
Quill.register("modules/imageResize", ImageResize);

import "./router/permission";
import "./registerServiceWorker";
import "./style/index.scss";
import "./utils/winResize";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueClipboard);
Vue.use(VueAreaLinkage);
Vue.use(VueQuillEditor);
Vue.use(Vuebar);
Vue.use(AppPlugin);
Vue.use(ElementUI, { size: "small", i18n: (key, value) => i18n.t(key, value) });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
